import React from 'react';
import PropTypes from 'prop-types';
import InternetBankingActions from '../../actions/InternetBankingActions';
import AccountPoolsActionCreator from '../../actions/AccountPoolsActionCreator';
import UserManagementStore from '../../stores/UserManagementStore';
import AccountPoolsStore from '../../stores/AccountPoolsStore';
import { NoAccountPoolExist } from './NoAccountPoolExist';
import { ListOfAccountPools } from './ListOfAccountPools';
import LoaderComponent from '../common/LoaderComponent';
import StepHeader from '../../includes/StepHeader';
import { LeftAndRightAlignment } from 'web-ui-components/lib/global/layout';
import { NavigationButton } from 'web-ui-components/lib/navigation/buttons';
import { PageHeading } from 'web-ui-components/lib/typography/headings';
import { SectionHeading } from 'web-ui-components/lib/molecules/text';

class AccountPools extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      accountPools: AccountPoolsStore.getAccountPools(),
      isAccountLoaded: AccountPoolsStore.isAccountLoaded(),
    };
  }
  componentWillMount() {
    AccountPoolsActionCreator.resetAccountDetailsFlag();
  }
  componentDidMount() {
    AccountPoolsActionCreator.getAccountPools();
    AccountPoolsActionCreator.getAccountList();
    AccountPoolsActionCreator.resetPool();
    AccountPoolsStore.addChangeListener(this.onChangeAccountPoolStore);
  }
  componentWillUnmount() {
    AccountPoolsStore.removeChangeListener(this.onChangeAccountPoolStore);
  }
  onChangeAccountPoolStore = () => {
    this.setState({
      isAccountLoaded: AccountPoolsStore.isAccountLoaded(),
      accountPools: AccountPoolsStore.getAccountPools(),
    });
  };
  onSelectAccountPool = (pool_id) => {
    AccountPoolsActionCreator.setAccountPoolId(pool_id);
    InternetBankingActions.navigateToWebTask('WEB-ACCOUNT-POOL-DETAILS');
  };
  render() {
    const { accountPools, isAccountLoaded } = this.state;
    const {
      manageAccountPools,
      manageAccountPools: {
        accountPoolsTitle,
        createAccountPool,
        accountPoolHeading,
      },
    } = this.props.content;
    const leftNode = <PageHeading>{accountPoolsTitle}</PageHeading>;
    const rightNode = (
      <NavigationButton.Primary
        labelText={createAccountPool}
        onClick={() =>
          InternetBankingActions.navigateToWebTask('WEB-CREATE-POOL')
        }
      />
    );
    const isAccountPoolsAvailable =
      accountPools && accountPools.pools && accountPools.pools.length;
    return (
      <div className="page container">
        <div className="account-pools__container">
          <StepHeader
            showheaderCrumbs
            onClick={() =>
              InternetBankingActions.navigateToWebTask('WEB-HOMEPAGE')
            }
            headerCrumbsMessage="Back"
            controlBack={this.back}
          />
          {isAccountLoaded ? (
            <div>
              <div className="web-ui-components">
                <LeftAndRightAlignment
                  leftNode={leftNode}
                  rightNode={
                    UserManagementStore.isCorporateAdmin() && rightNode
                  }
                />
              </div>
              <SectionHeading>
                <p>{accountPoolHeading}</p>
              </SectionHeading>
              <div className="account-pools__list-container">
                {isAccountPoolsAvailable ? (
                  <ListOfAccountPools
                    pools={accountPools.pools}
                    onSelectAccountPool={this.onSelectAccountPool}
                  />
                ) : (
                  <NoAccountPoolExist content={manageAccountPools} />
                )}
              </div>
            </div>
          ) : (
            <LoaderComponent type="large" />
          )}
        </div>
      </div>
    );
  }
}
AccountPools.propTypes = {
  content: PropTypes.object,
};
export default AccountPools;
